var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMultiDwellingUnit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5633",
    "data-name": "Group 5633",
    transform: "translate(-552.375 -477)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_861",
    "data-name": "Ellipse 861",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(552.375 477)",
    fill: "#fff4cf"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5647",
    "data-name": "Group 5647",
    transform: "translate(566.375 488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_28986",
    "data-name": "Path 28986",
    d: "M16,10l2.149.645c1.373.412,2.06.618,2.455,1.149s.4,1.248.4,2.682V22",
    fill: "none",
    stroke: "#c9790f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28987",
    "data-name": "Path 28987",
    d: "M8,9h3M8,13h3",
    fill: "none",
    stroke: "#c9790f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28988",
    "data-name": "Path 28988",
    d: "M12,22V19c0-.943,0-1.414-.293-1.707S10.943,17,10,17H9c-.943,0-1.414,0-1.707.293S7,18.057,7,19v3",
    fill: "none",
    stroke: "#c9790f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28989",
    "data-name": "Path 28989",
    d: "M2,22H22",
    fill: "none",
    stroke: "#c9790f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28990",
    "data-name": "Path 28990",
    d: "M3,22V6.717c0-2.511,0-3.766.791-4.389s1.956-.285,4.286.392l5,1.451c1.406.408,2.109.612,2.516,1.168S16,6.653,16,8.169V22",
    fill: "none",
    stroke: "#c9790f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiDwellingUnit);
export default __webpack_public_path__ + "static/media/multi_dwelling_unit.89cad1aa23ade469709a15d8188a826f.svg";
export { ForwardRef as ReactComponent };